import { Modal } from "react-bootstrap";
import Form from "../../../Components/Form/form";
import { useTranslation } from "react-i18next";
import { usePasswordForm } from "../../../Hook/Users/usePasswordForm";

export default function UserPasswordForm({ user, show, handleClose }) {
    const { t } = useTranslation(); // Hook para tradução

    const { passwordForm, setPasswordForm, handleFormSubmit, handleCancel } =
        usePasswordForm({ user, onClose: handleClose });

    // Configuração do formulário
    const formConfig = {
        isEditing: true,
        submitText: t("common.actions.update"),
        onSubmit: () => {
            handleFormSubmit();
        },
        onCancel: () => {
            handleCancel();
        },
        sections: [
            {
                columns: 1,
                fields: [
                    {
                        name: "password",
                        label: t("users.form.password-change.password.label"),
                        type: "password",
                        placeholder: t(
                            "users.form.password-change.password.placeholder"
                        ),
                        required: true,
                        errorMessages: {
                            required: t(
                                "users.form.password-change.password.errors.required"
                            ),
                        },
                    },
                    {
                        name: "confirm_password",
                        label: t(
                            "users.form.password-change.confirm-password.label"
                        ),
                        type: "password",
                        placeholder: t(
                            "users.form.password-change.confirm-password.placeholder"
                        ),
                        required: true,
                        errorMessages: {
                            required: t(
                                "users.form.password-change.confirm-password.errors.required"
                            ),
                        },
                        validate: (value) => {
                            console.log("passwordForm", passwordForm);
                            if (
                                passwordForm &&
                                value !== passwordForm.password
                            ) {
                                return t(
                                    "users.form.field.confirm-password.errors.match"
                                );
                            }
                            return null;
                        },
                    },
                ],
            },
        ],
        onChange: (newData) => {
            setPasswordForm(newData);
        },
        formData: passwordForm,
    };

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
                aria-labelledby="example-modal-sizes-title-lg"
                className="modal-create-user"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("users.form.password-change.title") +
                            " " +
                            user.name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form {...formConfig} />
                </Modal.Body>
            </Modal>
        </>
    );
}
